import React from 'react';
import { ReactComponent as Warning } from '@/assets/images/svg/warning.svg';

export const CloseEventContent: React.FC = (): JSX.Element => (
  <React.Fragment>
    <div className="exclude-container">
      <Warning color="#E64F49" />
      <div className="header-title-text modal__title">
        <h5 className="modal__confirmation-title">Você tem certeza que quer fechar esse evento?</h5>
      </div>
      <div className="modal__confirmation-text">
        Ao fechar esse evento o mesmo será migrado para a <strong>base histórica</strong> do
        sistema, podendo apenas visualizar os relatórios.
      </div>
    </div>
  </React.Fragment>
);
